import React, { useRef } from "react";
import cs from "classnames";
import { UncontrolledPopover, PopoverBody } from "reactstrap";

import { Icon } from "../Icon/Icon";

import "./InformationBox.scss";

interface Props {
  message?: string;
  leftDiff?: boolean;
  onClick?: () => void;
  className?: string;
  placement?: "top" | "bottom" | "left" | "right" | "auto";
}

export const InformationBox = (props: Props) => {
  const ref = useRef(null);

  const uniqueIdRef = useRef(
    `InformationBoxPopover-${Math.random().toString(36).substr(2, 9)}`
  );

  const mainClasses = cs("InformationBox", props.className, {
    "InformationBox--left-diff": props.leftDiff,
  });

  const handleClick = () => {
    if (props.onClick) {
      props.onClick();
    }
  };

  return (
    <>
      <div
        className={mainClasses}
        ref={ref}
        onClick={handleClick}
        id={uniqueIdRef.current}
      >
        <Icon icon="cursor-information" />
      </div>
      <UncontrolledPopover
        trigger="legacy"
        placement="bottom"
        target={uniqueIdRef.current}
        className="InformationBox__popover"
        container="body"
        fade={false}
      >
        <PopoverBody className="InformationBox__content">
          <div
            dangerouslySetInnerHTML={{
              __html:
                props.message && props.message.length > 0
                  ? props.message
                  : `<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                  Delectus commodi non quos hic sunt facilis! Quaerat, quia
                  pariatur. Sint consequuntur, quos officia aliquam dolor eum.
                  Veniam quos temporibus unde ullam!</p>`,
            }}
          />
        </PopoverBody>
      </UncontrolledPopover>
    </>
  );
};
